import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { Button, Collapse } from 'reactstrap';

import { userIsAdmin, userIsManager } from '../../../helpers/Auth';
import { getInitialOpenOnboardingStep, isOnboardingStepCompleted } from '../../../helpers/Onboarding';

import OnboardingStepHeader from './StepHeader';
import OnboardingSkipButton from './SkipButton';
import VideoShowcase from '../../VideoShowcase';

const OnboardingShare = ({ slug }) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(getInitialOpenOnboardingStep() === slug);

  const isCompleted = isOnboardingStepCompleted(slug);
  const initialOpenStep = getInitialOpenOnboardingStep();

  useEffect(() => {
    if (initialOpenStep === slug) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [slug, initialOpenStep]);

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <div className={classnames('onboarding-step', { 'onboarding-step-next': initialOpenStep === slug })}>
      <OnboardingStepHeader
        isOpen={isOpen}
        handleOpen={setIsOpen}
        title={intl.formatMessage({ defaultMessage: 'Share a file or collection' })}
        subtitle={intl.formatMessage({ defaultMessage: 'Share links externally, or give access to your team so they can collaborate.' })}
        isCompleted={isCompleted}
      />
      <Collapse isOpen={isOpen} className="onboarding-step-collapse">
        <div>
          <div className="onboarding-step-collapse-video">
            <VideoShowcase
              video="https://player.vimeo.com/video/1069786658?h=d8de73fac6&badge=0&byline=0&title=0"
              thumbnail="https://i.vimeocdn.com/video/1998179842-025f74f9c8a9224d3105f1b43304c29690aef63a349cffdc89340e817a4d1e93-d?mw=800&mh=450"
              title={intl.formatMessage({ defaultMessage: 'Share a file or collection' })}
            />
          </div>
          <div className="onboarding-step-collapse-buttons">
            <div>
              <Button
                color="link"
                tag="a"
                href="https://help.stockpress.co/en/articles/5937349-share-files-and-collections"
                target="_blank"
              >
                <i className="far fa-book mr-1" />
                {intl.formatMessage({ defaultMessage: 'Find out more' })}
              </Button>
            </div>
            <div>
              <OnboardingSkipButton slug={slug} isCompleted={isCompleted} />
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

OnboardingShare.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default OnboardingShare;
